module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"Aktuális egyenleg","flags":["TRACK"],"track":"Current Balance"}}